import { z } from 'zod';
/** Canonical client-facing error shape (ADR-019). */
export const errorEnvelopeSchema = z.object({
    status: z.number().int(),
    code: z.string(),
    message: z.string(),
    details: z.record(z.unknown()).optional(),
});
/** Raw server error props (Fastify / FetchError) before normalization. */
export const serverErrorInputSchema = z.object({
    status: z.number().int(),
    code: z.string(),
    message: z.union([z.string(), z.record(z.string())]).optional(),
    msg: z.string().optional(),
    meta: z.record(z.string()).optional(),
    error: z.string().optional(),
});
/** Normalize server `msg`/`meta`/`error` fields into canonical `ErrorEnvelope`. */
export const toErrorEnvelope = (input) => {
    const message = typeof input.message === 'string'
        ? input.message
        : typeof input.message === 'object'
            ? Object.values(input.message).join('; ')
            : (input.msg ?? input.error ?? '');
    const details = typeof input.message === 'object'
        ? { ...input.message }
        : input.meta
            ? { ...input.meta }
            : undefined;
    return {
        status: input.status,
        code: input.code,
        message,
        ...(details !== undefined && Object.keys(details).length > 0 ? { details } : {}),
    };
};
